import React, { Component } from "react";
import {
  Row,
  Col,
  Card,
  Icon,
  Button,
  Dropdown,
  Menu,
  List,
  Avatar,
  Divider,
  Modal,
  Badge,
  Collapse,
  Select,
  Checkbox,
  message
} from "antd";
import moment from "moment";
import F from "../../Functions";
import axios from "axios";
import Masonry from "react-masonry-component";
import "./landingpage.css";
import Thumb from "./images/bfile-thumb.jpg";
import Umbrella from "../LandingPage/images/Umbrella.png";
import Bike from "../LandingPage/images/bike.png";
import House from "../LandingPage/images/house.png";
import Car from "../LandingPage/images/car.png";
import Bfilelogo from "../LandingPage/images/bfile-logo.png";
import Bg from "../LandingPage/images/bg.png";
import Init from "./init";
import SetupAppointmentModal from "./parts/setup-appointment-modal";
import NotesModal from "./parts/notes-modal";
import TransferBFile from "./parts/transfer-bfile-modal";
import ChangeCreatorModal from "./parts/change-creator-modal";
import AddNoteModal from "./parts/add-note-modal";
import InvitationLinkModal from "./parts/invitation-link-modal";
import Print from "./parts/print";
import PrintPdf from "../../components/print-pdf/print-index";
import ActionMenu from "./menu";
import { Link } from "react-router-dom";
import { Translate } from "react-translated";
import UserEditModal from "./parts/user-edit-modal";
import "./landingpage.css";
import ClassicCar from "../Wizard/parts/images/bfile-classic_car.svg";
import RV from "../Wizard/parts/images/bfile-rv.svg";
import Boat from "../Wizard/parts/images/bfile-boat.svg";
import Motorcycle from "../Wizard/parts/images/bfile-motorcycle.svg";
import Drone from "../Wizard/parts/images/icon-drone.svg";
import GolfCart from "../Wizard/parts/images/bfile-golf_cart.svg";
import Watercraft from "../Wizard/parts/images/bfile-watercraft.svg";
import Snowmobile from "../Wizard/parts/images/bfile-snowmobile.svg";
import OffRoad from "../Wizard/parts/images/bfile-offroad.svg";
import SecondaryHome from "../Wizard/parts/images/bfile-homeowners.svg";
import MFGHome from "../Wizard/parts/images/bfile-mfg.svg";
import Condominium from "../Wizard/parts/images/bfile-condominium.svg";
import Landlord from "../Wizard/parts/images/bfile-landlord.svg";
import Renter from "../Wizard/parts/images/bfile-renter.svg";
import VacantProperty from "../Wizard/parts/images/bfile-vacant-land.svg";
import ReadMore from "../../components/read-more";
import { AGENCY_MANAGER, BOBADMIN, BOBREVIEWADMIN, EA, PROFILE_PDF_HEADERS, REVIEWADMIN, SUPER_ADMIN, VONBOARDER, VONSCHEDULER, get_label_from_value } from "../../utils/Constants";
import ShowReferrals from "./showReferrals";
import SentFollowupModal from "./parts/sent-followup-modal";
import CustomerProfile from "./components/CustomerProfile";
import { useBoundStore } from '../../store/useBoundStore';
import { GET_PREVIOUS_CALL_ATTEMPTS_COUNT, GET_REVIEW_ACTIVE_MONTH_DROP_DOWN_STATUS } from "../../utils/Api_enums";

const Panel = Collapse.Panel;
const { Option } = Select;

const customPanelStyle = {
  background: "#1890ff",
  marginBottom: 20,
  border: 0,
  borderRadius: 0,
  borderBottom: 0,
  overflow: "hidden"
};

//
// import Auto from "./images/bfile-classic_car.svg";

const confirm = Modal.confirm;

class LandingPage extends Component {
  state = {
    loading: true,
    bfile_id: null,
    token: null,
    bfile: {},
    user: this.props.auth.user,
    notes_loading: true,
    notes: [],
    few_notes: [],
    few_notes_copy: [],
    setup_appointment_modal: false,
    show_notes_modal: false,
    transfer_bfile_modal: false,
    change_creator_modal: false,
    add_note_modal: false,
    send_followup_modal: false,
    invitation_link_modal: false,
    history: [],
    show_user_edit_modal: false,
    b_fin_asset_401k_accounts: [],
    noteType: [],
    showreferrals: false,
    currentReferralsIndex: null,
    isRequestButtonDisable: { vonboard: 0, review: 0 , is_lead : 0 , is_opportunity : 0 },
    agency_owner_details: {},
    roles: JSON.parse(localStorage.getItem('roles')) || [],
    reviewActiveMonthDropDownStatus: null
  };

  componentDidMount = () => {

    if (this.state.user.user_type === "LSP" || this.state.user.user_type === "EA") {
      axios.get("/api/get_agency_owner_details").then(({ data: { error_response, agency_owner_details, success } }) => {
        if (success && !error_response) {
          this.setState({ agency_owner_details });
        } else {
          message.error(error_response)
        }
      })
    }

    this.loadUser()

    if (typeof this.props.match.params.token !== "undefined") {
      this.setState({ token: this.props.match.params.token }, () =>
        this.init()
      );
    } else {
      if (typeof this.props.match.params.bfile_id !== "undefined") {
        const bfile_id = this.props.match.params.bfile_id;
        const isVonschedulartoggle = (this.state.roles.includes("Review") &&   // NOSONAR
          (this.state.roles.includes("FollowUp") || this.state.roles.includes("Prospect")));  // NOSONAR
        this.setState({ bfile_id, isVonschedulartoggle }, () => this.init());   // NOSONAR
      } else {
        this.props.history.push("/404");
      }
    }
  };
  componentDidUpdate = () => {
    if (typeof this.props.match.params.bfile_id !== "undefined") {
      const bfile_id = this.props.match.params.bfile_id;
      if (bfile_id !== this.state.bfile_id) {
        this.setState({ bfile_id }, () => this.init());
      }
    }
  };

  loadUser() {
    let user = useBoundStore.getState().userInfo;
    if (!user) {
      axios.get("/api/user").then((res) => {
        if (res && res.data && res.data.user_agency_assoc[0] && res.data.user_agency_assoc[0].agency_id) {
          axios.get(`/api/agencies/${res.data.user_agency_assoc[0].agency_id}`).then((e) => {
            if (e && e.data) {
              this.setState({
                isRequestButtonDisable: { ...this.state.isRequestButtonDisable, vonboard: e.data.vonboard, review: e.data.review , is_lead : e.data.is_lead, is_opportunity : e.data.is_opportunity } // NOSONAR
              })
            }
          })
        }
      })
    } else {
      if (user && user.user_agency_assoc[0] && user.user_agency_assoc[0].agency_id) {
        axios.get(`/api/agencies/${user.user_agency_assoc[0].agency_id}`).then((e) => {
          if (e && e.data) {
            this.setState({
              isRequestButtonDisable: { ...this.state.isRequestButtonDisable, vonboard: e.data.vonboard, review: e.data.review , is_lead : e.data.is_lead, is_opportunity : e.data.is_opportunity }  // NOSONAR
            })
          }
        })
      }

    }


  }

  handleResponse = () => {
    let { bfile_id, token } = this.state;

    const res = {};

    res.data = {
      acknowledge_by: 0,
      action: null,
      action_date: null,
      address: "7997 W Olive Rd West Olive",
      address_cont: "",
      agency: {
        active: 1,
        address: "380 Garden Ave",
        billing_address: "",
        calculator_only: 0,
        created_on: "2022-06-10T14:37:05-04:00",
        email_status: 0,
        facebook: null,
        id: 1171,
        linkedin: null,
        name: "Jared Kimber-Farm Bureau MI",
        onboard_calls_time: null,
        primary_ea_id: 7338,
        region: null,
        review: 1,
        state: null,
        tier: null,
        twitter: null,
        updated_on: "2022-06-10T14:37:05-04:00",
        vonboard: 1
      },
      agency_id: 1171,
      archive: 0,
      asset_401k_accounts: '["None"]',
      asset_401k_accounts_spouse: '["None"]',
      asset_401k_accounts_toggle: 0,
      asset_401k_accounts_toggle_spouse: 0,
      asset_401k_value: 0,
      asset_accounts: '["IRA\'s","Annuities"]',
      asset_accounts_spouse: null,
      asset_preservation_toggle: null,
      asset_preservation_value: "",
      asset_preservation_value_spouse: "",
      asset_total_value: "$450,001-$500,000",
      asset_total_value_spouse: null,
      attempts: null,
      attention: [],
      auto_carrier: null,
      auto_expiration_date: null,
      auto_liability: null,
      auto_policy_not_sold_current_carrier: null,
      auto_policy_not_sold_current_liability_limit: null,
      auto_policy_not_sold_expiration_date: null,
      auto_policy_sold_bfile_limit: null,
      auto_policy_sold_current_liability_limit: null,
      auto_policy_sold_effective_date: null,
      auto_policy_sold_items_sold: null,
      auto_policy_sold_liability_limit_sold: null,
      auto_policy_sold_policy_premium: null,
      auto_policy_sold_term: null,
      auto_sold_toggle: null,
      bfile_folow_up_completed: null,
      bfile_need_attention: [],
      birthday: null,
      business_loan_toggle: null,
      business_name: "VANDEVEN DESIGN LC",
      business_name_spouse: null,
      business_owner_spouse_toggle: "1",
      business_owner_toggle: "1",
      business_retirement_value: null,
      business_type: "Other",
      business_type_other: null,
      business_type_other_spouse: null,
      business_type_spouse: null,
      calendly_eventdate: "2023-05-25T18:00:00",
      calendly_eventuri:
        "https://api.calendly.com/scheduled_events/005856e7-8599-4c64-ab47-02e11e16b9f7",
      calendly_location:
        '{"location":"380 Garden Ave. Holland, MI 49424","type":"physical"}',
      call_type: null,
      callback_time: null,
      callbacks: [],
      children: null,
      children_living_home_toggle: null,
      childs: [],
      city: "West Olive",
      coverage_detail_toggle: null,
      created_on: "2023-02-21T14:16:40-05:00",
      cross_sell: [],
      cross_sell_opportunities_quoted: 0,
      cross_sell_opportunities_sold: 0,
      cross_sell_policies_uncovered: 6,
      deleted: 0,
      ea: null,
      ea2: null,
      ea_id: null,
      ea_id2: null,
      efs: null,
      efs2: null,
      efs_id: null,
      efs_id2: null,
      email: "stef@ehl.net",
      employed_anual_income: "$50,001-$100,000",
      employed_anual_income_spouse: "$25,001-$50,000",
      employed_length: null,
      employed_length_spouse: null,
      employed_retired_disabled: null,
      employed_retired_disabled_spouse: null,
      employed_toggle: "",
      employed_toggle_spouse: "",
      employees_count: "1-5",
      employees_count_spouse: null,
      employer_name: "",
      employer_name_spouse: "",
      employer_retire_from: "",
      employer_retire_from_spouse: "",
      employer_years: "",
      employer_years_spouse: "",
      expiration_date: "2023-04-30T00:00:00",
      facebook: null,
      financial_calls_attempts: 0,
      financial_conversion: [],
      financial_id: null,
      financial_user: null,
      first_name: "MICHIEL",
      had_mortgage_review: null,
      home_bfile_liability: null,
      home_liability: null,
      home_liability_sold: null,
      home_market_value: "$450,001-$500,000",
      home_mortgage: null,
      home_mortgage_protection_benefit: null,
      home_mortgage_protection_benefit_spouse: null,
      home_mortgage_protection_policy: null,
      home_mortgage_protection_policy_spouse: null,
      home_mortgage_protection_toggle: "1",
      home_mortgage_protection_toggle_spouse: null,
      home_mortgage_toggle: null,
      home_policy_not_sold_current_carrier: null,
      home_policy_not_sold_current_liability_limit: null,
      home_policy_not_sold_expiration_date: null,
      home_policy_premium: null,
      home_policy_sold_bfile_limit: null,
      home_policy_sold_effective_date: null,
      home_policy_sold_items_sold: null,
      home_policy_sold_liability_limit: null,
      home_policy_sold_liability_limit_sold: null,
      home_policy_sold_policy_premium: null,
      home_policy_sold_term: null,
      home_sold_toggle: null,
      home_toggle: "1",
      id: 397576,
      insurance_score: null,
      internet_leads: 0,
      invite_password: null,
      is_appointment_kept: 0,
      is_appointment_made: 0,
      is_appointment_sold: 0,
      is_lead: 0,
      is_onboarded: 0,
      is_renewal: 1,
      is_requote: 0,
      is_saved_for_later: 0,
      is_sent_to_financial: 0,
      language: null,
      last_bfile_id: null,
      last_name: "VANDEVEN",
      liability_calculator_value: "1430000",
      life_opportunities: 0,
      life_opportunities_received: 0,
      life_opportunities_sold: 0,
      linkedin: null,
      lsp: null,
      lsp2: null,
      lsp_id: null,
      lsp_id2: null,
      mb_archived: null,
      merged_with_parent_id: null,
      mortgage_purchase_home: null,
      mortgage_referral: null,
      mortgage_review: null,
      mortgage_review_approved: null,
      need_attention: 0,
      no_follow_up: null,
      no_policies_sold: 0,
      nosalearchive_expiration_date: null,
      not_interested: 0,
      onboarder: null,
      onboarder_id: null,
      onboarding_id: null,
      onboarding_user: null,
      parent_id: null,
      personal_property_toggle: 0,
      personal_property_type: "[]",
      personal_property_value: "",
      phone: "6163997997",
      phone2: "",
      policies: [
        {
          bfile_id: 397576,
          created_on: "2023-05-25T15:21:34-04:00",
          id: 71153,
          policy_bfile_limit: null,
          policy_coverage: null,
          policy_current_carrier: null,
          policy_current_liability_limit: null,
          policy_effective_date: null,
          policy_items_sold: null,
          policy_liability_limit: null,
          policy_liability_limit_sold: null,
          policy_policy_premium: null,
          policy_premium_sold: null,
          policy_sold: null,
          policy_term: null,
          policy_type: "RV",
          policy_type2: "RV:",
          policy_umbrella: null,
          updated_on: "2023-05-25T15:21:34-04:00"
        },
        {
          bfile_id: 397576,
          created_on: "2023-05-25T15:21:34-04:00",
          id: 71154,
          policy_bfile_limit: null,
          policy_coverage: null,
          policy_current_carrier: null,
          policy_current_liability_limit: null,
          policy_effective_date: null,
          policy_items_sold: null,
          policy_liability_limit: null,
          policy_liability_limit_sold: null,
          policy_policy_premium: null,
          policy_premium_sold: null,
          policy_sold: null,
          policy_term: null,
          policy_type: "Secondary Home",
          policy_type2: "Secondary Home:",
          policy_umbrella: null,
          updated_on: "2023-05-25T15:21:34-04:00"
        }
      ],
      policy_umbrella_total: 1,
      primary_vehicles_num: 3,
      primary_vehicles_toggle: "1",
      profile_photo: null,
      questions: [],
      quote_auto_toggle: null,
      quote_home_toggle: null,
      referral_data: [],
      referral_id: null,
      renewals: 0,
      reschedule_appointment_vo: false,
      retirement_dollars: 500000,
      retirement_plan: null,
      retirement_plan_spouse: null,
      retirement_plan_value: null,
      retirement_plan_value_spouse: null,
      review: 1,
      reviewer_id: 7176,
      reviewer_user: {
        active: true,
        address: null,
        address_cont: null,
        admin: false,
        appointment_hours: null,
        auto_underlying_limit: null,
        calendly_access_token: null,
        calendly_expires_in: null,
        calendly_organization: null,
        calendly_refresh_token: null,
        calendly_rs_setup_appointment: null,
        calendly_vo_setup_appointment: null,
        carrier: null,
        city: null,
        company_name: null,
        coupon_code: null,
        created_on: "2021-12-17T16:39:42-05:00",
        default_date: null,
        email: "stephiebriand3@gmail.com",
        email_cron_notification: 1,
        email_game_notification: 1,
        email_sale_notification: 1,
        email_stats_notification: 1,
        email_status: 0,
        first_name: "Stephanie",
        hidden: false,
        home_underlying_limit: null,
        id: 7176,
        invited_by: 5279,
        jobs: null,
        language: null,
        last_login: "2023-06-08T13:52:30",
        last_login_temp: null,
        last_name: "Schloss",
        minimum_liability_limits: null,
        minimum_liability_limits_ext: null,
        mobile_number: null,
        password:
          process.env.REACT_APP_PASSWORD_HASH,
        password_reset_token: null,
        phone: null,
        phone_ext: null,
        registration_token: null,
        reward_program_enabled: null,
        state: null,
        stripe_card_id: null,
        stripe_customer_id: null,
        stripe_onboard_subscription_id: null,
        stripe_subscription_id: null,
        subscription: null,
        suggested_minimum_life_insurance: null,
        super_admin: false,
        tango_card_amount: null,
        tango_card_token: null,
        tango_card_token_v2: null,
        tango_customer: null,
        tango_identifier: null,
        tango_identifier_v2: null,
        timezone: "US/Eastern",
        timezone_offset: "-5",
        update_token: null,
        updated_on: "2021-12-17T16:39:42-05:00",
        user_note: null,
        user_tier: null,
        user_type: "REVIEWSCHEDULER",
        virtual_link: null,
        vob_financial_advisor: null,
        zipcode: null
      },
      rollover_dollars_created: null,
      rollover_opportunities: 0,
      rs_action: 1,
      rs_appointment_date: "2023-05-25T14:00:00-04:00",
      rs_archived: null,
      rs_attempts: 2,
      rs_call_made: 1,
      rs_date: "2023-05-19T22:13:40",
      rs_effective_date: "",
      rs_notreached_date: "2023-04-04T16:12:47",
      rs_policy_type: "REVIEW",
      rs_scheduled_date: "2023-05-19T22:13:40",
      secondary_home_market_value: "$250,001-$300,000",
      secondary_home_mortgage: null,
      secondary_home_mortgage_toggle: null,
      secondary_home_toggle: "1",
      secondary_home_type: '["Secondary Home"]',
      secondary_mortgage_protection_benefit: null,
      secondary_mortgage_protection_policy: null,
      secondary_mortgage_protection_toggle: null,
      secondary_vehicles: '["RV"]',
      secondary_vehicles_toggle: "1",
      secondary_vehicles_value: "$1-$10,000",
      sent_to_efs_date: null,
      sp_500: 0,
      sp_date: null,
      sp_price: null,
      spouse_birthday: null,
      spouse_first_name: "STEPHANIE",
      spouse_last_name: "VANDEVEN",
      spouse_toggle: null,
      state: "MI",
      status: "Renewal",
      status_spouse: null,
      timezone: "US/Eastern",
      token: "87f80ebe-4342-4bae-b36b-aeb37d",
      twitter: null,
      type_of_call: "Review",
      umbrella_limit: "2000000",
      umbrella_policy_quoted: 0,
      umbrella_policy_sold: 0,
      umbrella_policy_uncovered: 0,
      updated_on: "2023-05-25T15:21:34-04:00",
      user: {
        active: true,
        address: "380 Garden Ave",
        address_cont: null,
        admin: false,
        appointment_hours: null,
        auto_underlying_limit: "",
        calendly_access_token:
          process.env.REACT_APP_CALENDLY_TOKEN_TWO,
        calendly_expires_in: "2023-06-09T12:22:27",
        calendly_organization:
          "https://api.calendly.com/organizations/FCGALH3BI64XEABS",
        calendly_refresh_token: "3bGy01vS7cY0iGYj3vx2L7wDmYHl2P8aNpFe6gnlbzs",
        calendly_rs_setup_appointment:
          "https://api.calendly.com/event_types/ABFKQQVYFHZYK5H4",
        calendly_vo_setup_appointment:
          "https://api.calendly.com/event_types/08d581cd-ee14-4e72-8a17-f20106de2be0",
        carrier: "Farm Bureau",
        city: "Holland",
        company_name: "Jared Kimber-Farm Bureau MI",
        coupon_code: "onlysoftware",
        created_on: "2022-06-10T14:37:00-04:00",
        default_date: 10,
        email: "jaredkimber@fbinsmi.com",
        email_cron_notification: 1,
        email_game_notification: 1,
        email_sale_notification: 1,
        email_stats_notification: 1,
        email_status: 0,
        first_name: "Jared",
        hidden: false,
        home_underlying_limit: "",
        id: 7338,
        invited_by: null,
        jobs: null,
        language: null,
        last_login: "2023-06-08T18:00:40",
        last_login_temp: null,
        last_name: "Kimber",
        minimum_liability_limits: null,
        minimum_liability_limits_ext:
          '{"Home":"300,000","Suggested Minimum Life Insurance":"3x","Auto":"250/500"}',
        mobile_number: "6162121696",
        phone: "6163963333",
        phone_ext: null,
        reward_program_enabled: 1,
        state: "MI",
        stripe_onboard_subscription_id: null,
        suggested_minimum_life_insurance: null,
        super_admin: false,
        tango_card_amount: null,
        tango_card_token: null,
        tango_card_token_v2: null,
        tango_customer: "price_1iedol2dvwmkifc53mwjwvii",
        tango_identifier: null,
        tango_identifier_v2: "bfile-user-7338",
        timezone: "US/Eastern",
        timezone_offset: "-5",
        update_token: null,
        updated_on: "2022-06-10T14:37:00-04:00",
        user_note: null,
        user_tier: null,
        user_type: "EA",
        virtual_link: null,
        vob_financial_advisor: null,
        zipcode: "49424"
      },
      user_id: 7338,
      vip: 0,
      vo_claim_date: null,
      vo_sent_date: null,
      vob_archived: null,
      vob_attempted: null,
      vob_completed: null,
      von_appointment_date: null,
      vonboard: 0,
      zipcode: "49460"
    };

    bfile_id = res.data.id;

    let parent_bfile = bfile_id;
    if (res.data.parent_id) {
      parent_bfile = res.data.parent_id;
    }

    const q = {
      filters: [
        {
          or: [
            { name: "id", op: "==", val: parent_bfile },
            { name: "parent_id", op: "==", val: parent_bfile }
          ]
        }
      ]
    };
    axios.get("/api/b_file?q=" + JSON.stringify(q)).then((res) => {
      this.setState({
        history: res.data.objects
      });
    });

    // axios.get("/api/get_bfile_notes/" + bfile_id).then((res) => {
    //   const few_notes = [];
    //   let len = res.data.length;
    //   F.log("Notes Response =>", res.data);
    //   if (len > 2) len = 2;
    //   for (var i = 0; i < len; i++) {
    //     few_notes.push(res.data[i]);
    //   }
    //   this.setState({
    //     notes: res.data,
    //     few_notes,
    //     notes_loading: false,
    //   });
    // });

    const notes_list = [
      {
        bfile_id: 397576,
        note:
          "Had a review with Michiel and Stephanie. On the auto, Stephanie was not a named insured. Missing a University of Michigan alumni discount, also quoting an umbrella and potentially adding the umbrella MPD. Looks like a total annual savings of $324 for these three changes. They want a quote for a $1 million umbrella (said they thought they already had one). One the home need to remove Hay storage building 4 (if fell over due to age), need to quote the horse trailer valued at $13,000 (not on policy now), check to see if two tractors are covered under blanket farm property (one worth $1,200 the other $4,600). They have their own horses and occasionally board 1, need to make sure one horse is listed on the policy. Stephanie has a term policy elsewhere for $250k for her sister who they wanted to help should anything happen to her. Michiel doesn't have life insurance but they want quotes. Need to send a few showing $250k-$500k. Michael is an engineer (self employed) and designs products for a few different companies. He's interested in the cost of professional liability coverage should he ever get roped into a lawsuit. They aren't overly concerned but curious about the cost.",
        is_acknowledgement: null,
        created_on: "2023-05-25T17:03:11-04:00",
        user_name: "Jared Kimber"
      },
      {
        bfile_id: 397576,
        note:
          "Mrs. Vandeven scheduled an in office appointment for Thursday 5/25 at 2pm.",
        is_acknowledgement: null,
        created_on: "2023-05-19T18:13:41-04:00",
        user_name: "Stephanie Schloss"
      },
      {
        bfile_id: 397576,
        note: "Appointment scheduled through Calendly.",
        is_acknowledgement: null,
        created_on: "2023-05-19T18:07:00-04:00",
        user_name: "Stephanie Schloss"
      },
      {
        bfile_id: 397576,
        note: "Not Reached.",
        is_acknowledgement: null,
        created_on: "2023-04-04T16:12:48-04:00",
        user_name: "Stephanie Schloss"
      },
      {
        bfile_id: 397576,
        note:
          "Mrs. Vandeven was a little spooked by the change but wanted to schedule and needed to speak with her husband first. I made sure she also had the office number and the address.",
        is_acknowledgement: null,
        created_on: "2023-04-04T16:12:48-04:00",
        user_name: "Stephanie Schloss"
      },
      {
        bfile_id: 397576,
        note: "Appointment scheduled through Calendly.",
        is_acknowledgement: null,
        created_on: "2023-04-04T16:08:08-04:00",
        user_name: "Stephanie Schloss"
      },
      {
        bfile_id: 397576,
        note: "former Hop Agency customer",
        is_acknowledgement: null,
        created_on: "2023-02-21T14:16:40-05:00",
        user_name: "Jared Kimber"
      }
    ];

    const few_notes = [];
    let len = notes_list.length;
    if (len > 2) len = 2;
    for (var i = 0; i < len; i++) {
      few_notes.push(notes_list[i]);
    }
    this.setState({
      notes: notes_list,
      few_notes,
      few_notes_copy: few_notes,
      notes_loading: false
    });

    this.setState(
      {
        bfile: res.data,
        loading: false
      },
      () => {
        if (typeof this.props.match.params.action !== "undefined") {
          const action = this.props.match.params.action;
          if (action === "print") {
            Print();
          }
        }
      }
    );
  };

  init = () => {
    let { bfile_id, token, user, isVonschedulartoggle } = this.state;
    this.setState({ loading: true });
    let url;
    const historyState = this.props.history.location;
    if (user.user_type == AGENCY_MANAGER || user.user_type == SUPER_ADMIN || user.user_type == VONSCHEDULER || user.user_type == EA && user.id == 2 ||
      user.user_type == REVIEWADMIN || user.user_type == BOBADMIN || user.user_type == BOBREVIEWADMIN) {
      url = "/api/b_file_admins/" + bfile_id;
    } else {
      url = "/api/b_file/" + bfile_id + (user.user_type === 'SUPER_ADMIN' && historyState.state && historyState.state.user_type && `?user_type=${historyState.state && historyState.state.user_type}` || '');
    }

    if (isVonschedulartoggle) {
      const roleFilter = useBoundStore.getState().RSFSCardFilters.selectedToggleAPI;
      const params = new URLSearchParams({ role_filter: roleFilter }).toString();
      url = `/api/b_file/${bfile_id}?${params}`;
    }



    if (token) {
      url =
        '/api/bfile_token?q={"filters":[{"name":"token","op":"==","val":"' +
        token +
        '"}]}';
    }

    // this.handleResponse();

    axios
      .get(url)
      .then((res) => {
        if (
          typeof res.data.objects !== "undefined" &&
          res.data.objects.length > 0
        ) {
          res.data = res.data.objects[0];
        }

        bfile_id = res.data.id;

        let parent_bfile = bfile_id;
        if (res.data.parent_id) {
          parent_bfile = res.data.parent_id;
        }

        const q = {
          filters: [
            {
              or: [
                { name: "id", op: "==", val: parent_bfile },
                { name: "parent_id", op: "==", val: parent_bfile }
              ]
            }
          ]
        };
        axios.get("/api/b_file?q=" + JSON.stringify(q)).then((res) => {
          this.setState({
            history: res.data.objects
          });
        });

        axios.get("/api/get_bfile_notes/" + bfile_id).then((res) => {
          const few_notes = [];
          let len = res.data.length;
          F.log("Notes Response =>", res.data);
          if (len > 2) len = 2;
          for (var i = 0; i < len; i++) {
            few_notes.push(res.data[i]);
          }

          this.setState({
            notes: res.data,
            notes_copy: res.data,
            few_notes,
            few_notes_copy: few_notes,
            notes_loading: false
          });
        });

        this.setState(
          {
            bfile: res.data,
            loading: false
          },
          () => {


            if (this.state.bfile.id && this.state.bfile.type_of_call) {
              axios
                .get(GET_REVIEW_ACTIVE_MONTH_DROP_DOWN_STATUS(this.state.bfile.type_of_call, this.state.bfile.id))
                .then((res) => {
                  if (res && res.data && res.data.success) {
                    this.setState({ reviewActiveMonthDropDownStatus: res.data });
                  }
                })
                .catch((err) => {
                  console.error("Error fetching active month drop-down status:", err);
                });


              axios.get(GET_PREVIOUS_CALL_ATTEMPTS_COUNT(this.state.bfile.id)).then((res) => {
                if (res && res.data && res.data.success) {
                  this.setState({
                    previousCallAttemptCount: res.data.previous_attempts_count
                  })
                }
              }).catch((err) => {
                console.error("Error fetching previous Call Attempt Count:", err);
              });

            }


            if (!this.state.bfile.type_of_call) {
              this.setState({
                reviewActiveMonthDropDownStatus: {
                  isReviewMonthDropDownHidden: true
                }
              });
            }


            if (typeof this.props.match.params.action !== "undefined") {
              const action = this.props.match.params.action;
              if (action === "print") {
                Print();
              }
            }
          }
        );
      })
      .catch((e) => {
        if (e.response.status === 404) {
          F.showAndHandleServerError(e);
          // this.props.history.push("/404");
          this.props.history.push("/dashboard");
        }
      });




  };

  edit = () => {
    window.localStorage.bfileType = "new";
    setTimeout(() => {
      this.props.history.push({ pathname: "/wizard/step/1/" + this.state.bfile_id, state: { ...this.props.history.location.state } });
    }, 100);
  };
  goTo = (path) => {
    this.props.history.push(path);
  };
  print = () => {
    // return <PrintPdf
    // // bfileId={this.state.bfile.id}
    // />
    Print();
  };
  createQuickFollowUpCall = () => {
    const { bfile } = this.state;

    window.localStorage.bfileType = "quick";
    window.localStorage.removeItem("wizard");

    setTimeout(() => {
      this.props.history.push("/wizard/step/13/" + bfile.id, {
        quickFollowUp: true,
        ...this.props.history.location.state
      });
    }, 100);
  };


  handleChangeNoteType = (type) => {
    let few_notes = this.state.notes_copy.filter(e => !type.length ? true : type.includes(e.notes_type))  // NOSONAR
    this.setState({ noteType: type, few_notes_copy: few_notes })
  }


  cardCssBasedonCardId = (id) => {
    if (id === "card_household") {
      return ""
    }
    if (id === "card_status") {
      return "profile-status-card"
    }
    if (id === "card_life_stage") {
      return "profile-detail-card"
    }
    if (id === "card_employment") {
      return "card_employment_card_financial_rec_min_height"
    }
    if (id === "card_financial_rec") {
      return "card_employment_card_financial_rec_min_height"
    }
    // if(id==="card_asset_accounts"){
    //   // return "status-life-stage-asstets-account"
    //   return "wide-card"
    // }


    //  below 2 card css starts here 
    if (id === "card_financial_rec") {
      return "b-financial-status-employeement"
    }
    if (id === "card_employment") {
      return "b-financial-status-employeement"
    }
  }

  handleCardWrapperWidth(id) {

    if (id === "card_household") {
      return "wide-card assets-card"
    } else if (id === "card_cross_sell_opp") {
      return "wide-card pc-items-card-icon-css"
    } else if (id === "card_status") {
      return "wide-card"
    } else if (
      id === "card_life_stage" ||
      id === "card_employment" ||
      id === "card_asset_accounts"
    ) {
      return "profile-third-card"
    }
    else {
      return "dynamic-card"
    }




    // card.id === "card_household"
    //                         ? "wide-card"
    //                         : "dynamic-card"

  }

  refreshNotes = () => {
    this.init();
  };




  render() {
    const {
      bfile,
      bfile_id,
      loading,
      notes_loading,
      notes,
      user,
      few_notes,
      show_notes_modal,
      show_user_edit_modal,
      noteType,
      few_notes_copy,
      agency_owner_details,
      reviewActiveMonthDropDownStatus,
      previousCallAttemptCount

    } = this.state;
    let icon = null;
    let landingPageCards = [];


    if (bfile.id && reviewActiveMonthDropDownStatus) {
      landingPageCards = Init(
        bfile,
        agency_owner_details,
        this.refreshNotes,
        reviewActiveMonthDropDownStatus,
        previousCallAttemptCount
      );
    }

    let b_fin_asset_401k_accounts = bfile.asset_401k_accounts;
    F.log("b_fin_asset_401k_accounts", b_fin_asset_401k_accounts);

    F.log("b_fin_asset_401k_accounts", b_fin_asset_401k_accounts);
    const style = { backgroundImage: "url(./images/bg.webp)" };

    // new code added
    // bfile.asset_accounts_obj = [];
    // if (bfile.asset_accounts !== null && bfile.asset_accounts !== "") {
    //   bfile.asset_accounts_obj = bfile.asset_accounts
    //     ? JSON.parse(bfile.asset_accounts)
    //     : [];
    // }

    // bfile.asset_accounts_obj_spouse = [];

    // if (
    //   bfile.asset_accounts_spouse !== null &&
    //   bfile.asset_accounts_spouse !== ""
    // ) {
    //   bfile.asset_accounts_obj_spouse = bfile.asset_accounts_spouse
    //     ? JSON.parse(bfile.asset_accounts_spouse)
    //     : [];
    // }

    // F.log("BMG --------------------------------");
    // F.log(
    //   "BMG policies ==>> " +
    //     JSON.stringify(bfile.policies) +
    //     " type of ==>> " +
    //     typeof bfile.policies
    // );

    const {
      Life_Stage,
      Household_Total_Assets,
      P_n_C_ITEMS_IN_THE_HOUSEHOLD
    } = PROFILE_PDF_HEADERS;

    const checkIfLifeStageHeaderHasContent = F.checkProfilePDFHeaderHasContent(
      bfile,
      Life_Stage
    );

    const checkHouseholdAssetsHeaderHasContent = F.checkProfilePDFHeaderHasContent(
      bfile,
      Household_Total_Assets
    );

    const checkPnCItemsHeaderHasContent = F.checkProfilePDFHeaderHasContent(
      bfile,
      P_n_C_ITEMS_IN_THE_HOUSEHOLD
    );

    // check `Financial Recommendations` has content
    const asset_401k_accounts_has_data =
      bfile.asset_401k_accounts &&
      JSON.parse(bfile.asset_401k_accounts).length > 0;
    const asset_401k_accounts_spouse_has_data =
      bfile.asset_401k_accounts_spouse &&
      JSON.parse(bfile.asset_401k_accounts_spouse).length > 0;
    const asset_accounts_obj_has_data =
      bfile.asset_accounts_obj && bfile.asset_accounts_obj.length > 0;

    const show_financial_recommendations =
      asset_401k_accounts_has_data ||
      asset_401k_accounts_spouse_has_data ||
      asset_accounts_obj_has_data;





    const parentInstance = this;
    return (
      <div id="landingPage">
        {/* print jsx start here  */}

        {/* print jsx end here  */}

        {/*  jsx for page start here  */}
        <div className="hide-print">
          {Object.keys(bfile).length > 0 && <CustomerProfile
            bfile={bfile}
            loading={loading}
            user={user}
            show_user_edit_modal={show_user_edit_modal}
            noteType={noteType}
            notes_loading={notes_loading}
            few_notes_copy={few_notes_copy}
            notes={notes}
            parentInstance={parentInstance}
            init={this.init}
            history={this.props.history}
          />}

          <div className="gutter"></div>

          <span className="mansory-container-list" style={{ width: "101%" }}>
            <Masonry className="my-gallery-class" elementType="div">
              <div className="card-container">
                {landingPageCards.map((card, i) => {
                  if (card.data.length > 0) {
                    return (
                      <div
                        key={i}
                        className={`card-wrapper ${this.handleCardWrapperWidth(card.id)}`}
                      >
                        <Card
                          title={
                            card.id === "card_household" ? (
                              ""
                            ) : (
                              <span className="text-16 color-164897">
                                {card.title}
                              </span>
                            )
                          }
                          className={`custom-card my-heading-css 
                            ${this.cardCssBasedonCardId(card.id)}
                            `}
                          type="inner"
                        >
                          <List
                            className={
                              card.id === "card_household"
                                ? "profile-household-summary-list"
                                : card.id === "card_status"
                                  ? "profile-status-list"
                                  : ""
                            }
                            loading={loading}
                            itemLayout="horizontal"
                            dataSource={card.data}
                            renderItem={(item) => (
                              <List.Item
                                className={`${card.id === "card_household"
                                  ? `profile-household-summary-item profile-household-${item.key || "item"}`
                                  : "listCard"} ${item.className || ""}`}
                              >
                                <List.Item.Meta
                                  // className="card_household_css"
                                  className={`card_household_css ${card.id === 'card_household' ? 'card_household_res' : ''}`}
                                  title={
                                    card.id === "card_household" ? (
                                      <span className="profile-household-summary-title text-16 color-164897 padding-right-20 padding-left-20">
                                        {item.name}
                                      </span>
                                    ) : (
                                      item.name
                                    )
                                  }
                                  description={
                                    card.id === "card_household" ? (
                                      <span className={item.isPrimary
                                        ? "text-36"
                                        : "profile-liability-summary-value"}>
                                        {item.value}
                                      </span>
                                    ) : (
                                      <div>
                                        {F.transformCallTypeLabel(item.value)}
                                      </div>

                                    )
                                  }
                                />
                              </List.Item>
                            )}
                          />
                        </Card>
                      </div>
                    );
                  } else {
                    return null;
                  }
                })}
              </div>
            </Masonry>
          </span>

          {this.state.history.length > 1 ? (
            <Collapse style={customPanelStyle}>
              <Panel header="History" key="1">
                <List
                  loading={loading}
                  itemLayout="horizontal"
                  dataSource={this.state.history}
                  renderItem={(item) => (
                    <List.Item>
                      <Link to={"/customer/" + item.id}>
                        <List.Item.Meta
                          title={item.first_name + " " + item.last_name}
                          description={moment(item.created_on).format(
                            "MM/DD/YYYY"
                          )}
                          className={item.id === bfile.id ? "current" : ""}
                        />
                      </Link>
                    </List.Item>
                  )}
                />
              </Panel>
            </Collapse>
          ) : null}

          {/* NotesModal render on condition true/false */}
          {
            this.state.show_notes_modal && (
              <NotesModal
                showModal={this.state.show_notes_modal}
                hideModal={() => this.setState({ show_notes_modal: false })}
                notes={notes}
                notes_loading={notes_loading}
                noteType={noteType}
              />
            )
          }
          {/* SentFollowupModal render based on conditon  */}
          {
            this.state.send_followup_modal && (
              <SentFollowupModal
                history={this.props.history}
                showModal={this.state.send_followup_modal}
                hideModal={() => this.setState({ send_followup_modal: false })}
                requestButtonVisiblelanding={this.state.isRequestButtonDisable}
                bfile={bfile}
                user={user}
              />
            )
          }
          {/* AddNoteModal render when conditon true  */}
          {!loading && this.state.add_note_modal ? (
            <AddNoteModal
              showModal={this.state.add_note_modal}
              hideModal={() => this.setState({ add_note_modal: false })}
              bfile={bfile}
              user={user}
              init={this.init}
            />
          ) : null}

          {/*  SetupAppointmentModal render when conditon true */}
          {!loading && this.state.setup_appointment_modal ? (
            <SetupAppointmentModal
              history={this.props.history}
              showModal={this.state.setup_appointment_modal}
              hideModal={() =>
                this.setState({ setup_appointment_modal: false })
              }
              bfile={bfile}
              user={user}
            />
          ) : null}
          {/* InvitationLinkModal render when condition true */}
          {!loading && this.state.invitation_link_modal ? (
            <InvitationLinkModal
              history={this.props.history}
              showModal={this.state.invitation_link_modal}
              hideModal={() => this.setState({ invitation_link_modal: false })}
              bfile={bfile}
              user={user}
            />
          ) : null}
        </div>
      </div>
    );
  }
}

export default LandingPage;



// WEBPACK FOOTER //
// ./src/scenes/LandingPage/index_updated.js